// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2K3b0","selects":"Documents_selects__ua_LE"};